import TextField from '../../text-field/TextField';

const Search = ({ placeholder, value, cb, sx }) => {
  return (
    <TextField
      id="search-field"
      value={value}
      label="Search"
      size="small"
      placeholder={placeholder}
      onChange={cb}
      sx={sx}
    />
  );
};

export default Search;
